<template>
  <div class="fixed right-4 top-4 z-40 flex flex-col gap-3">
    <TransitionsFade :group="true">
      <UiAlertItem
        v-for="alert in alertStore.alerts"
        :key="alert.id"
        v-bind="alert"
        shadow
        @close="alertStore.remove(alert.id)"
      />
    </TransitionsFade>
  </div>
</template>

<script setup lang="ts">
import { useAlertStore } from '~/stores/alert/alertStore';

const alertStore = useAlertStore();
</script>
